import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, PopoverController } from 'ionic-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotfallrufnummernPopup } from '../../components/popups/NotfallrufnummernPopup'
import { eGENA_Teilnehmerspezifisches } from '../../visionet/Teilnehmerspezifisches';
import { Storage } from '@ionic/storage';
import { KlinikkennungEingabePopup } from '../popups/KlinikkennungEingabePopup';
import { HaftungsausschlussPopup } from '../popups/HaftungsausschlussPopup';

import { GlobalConstants } from '../../app/core/GlobalConstants';



@Component({
	selector: 'MenuBarIcons',
	templateUrl: 'MenuBarIcons.html'
})
export class MenuBarIconsComponent {

	/**	=== Visionet(sl) ==========
	 *	Beim Aufruf des Konstruktors ist der Eingangs-Parameter `notfallrufnummern` noch undefiniert.
	 *	Wir brauchen den Konstruktor nur um den `DomSanitizer` und en `PopoverController` zu erhalten.
	 */
	constructor(public navCtrl: NavController, public sanitizer: DomSanitizer, public popoverCtrl: PopoverController, public storage: Storage) {
	}

	/**	=== Visionet(sl) ==========
	 * 	Zeigt die hinterlegtenInformationen zu Notrufnummern an. Das kommt aus dem JSON.Attribut GlobalConstants.STORAGE_KEY_TEILNEHMERKENNUNG."Notrufnummern"
	 */ 
	oeffneNotfallrufnummernPopup(event: UIEvent) : void {
		this.storage.get(GlobalConstants.STORAGE_KEY_TEILNEHMERSPEZIFISCHES).then((teilnehmerspezifisches : eGENA_Teilnehmerspezifisches) => {
			if (teilnehmerspezifisches) {
				let notfallrufnummernText = teilnehmerspezifisches.Notrufnummern;
				let notfallrufnummernHtml : SafeHtml = this.sanitizer.bypassSecurityTrustHtml(notfallrufnummernText);

				let popover = this.popoverCtrl.create(
					NotfallrufnummernPopup,
					{ "data": notfallrufnummernHtml },
					//PopoverOptions
					{ cssClass: "notfallrufnummern",
						showBackdrop: true,
						enableBackdropDismiss: true
					}
					);
				popover.present({
				});
			}
		})
	}

	oeffnePersonalisierungsPopup(event: UIEvent) : void {
		let popover = this.popoverCtrl.create(
			KlinikkennungEingabePopup,
			// data
			undefined,
			//PopoverOptions
			{ cssClass: "personalisierung",
				showBackdrop: true,
				enableBackdropDismiss: true
			}
		);
		popover.present({
		});
		popover.onDidDismiss((data: any, role:string) => {
			if (data && data?.goToRoot) {
				this.navCtrl.goToRoot({
					animate : true,
					animation: "ios-transition"
				});
			}
		});

	}


	oeffneHinweisPopup(event: UIEvent) : void {
		let popover = this.popoverCtrl.create(
			HaftungsausschlussPopup,
			// data
			{ "showCheckbox": false },
			//PopoverOptions
			{ cssClass: "haftungsausschluss",
				showBackdrop: true,
				enableBackdropDismiss: true
			}
		);
		popover.present({
		});
	}

}



// WEBPACK FOOTER //
// ./src/components/MenuBarIcons/MenuBarIcons.ts